module.exports = __webpack_public_path__ + "img/succeed.134630fb.png";